import { NativeError } from '../constants/minification/native-error.const.mjs';
import { normalizeIdentifier } from '../utils/normalize-identifier.util.mjs';
/**
 * Thrown when DI cannot inject value into property decorated by `@Inject` decorator.
 *
 * @group Errors
 */
export class CannotInstantiateValueError extends NativeError {
    constructor(identifier, footer = '') {
        super();
        this.footer = footer;
        this.name = 'CannotInstantiateValueError';
        this.normalizedIdentifier = normalizeIdentifier(identifier);
        this.message =
            `Cannot instantiate the requested value for the "${this.normalizedIdentifier}" identifier. ` +
                `The related metadata doesn't contain a factory or a type to instantiate. ` +
                this.footer;
    }
}
//# sourceMappingURL=cannot-instantiate-value.error.mjs.map